var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoaccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#6600DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.524 15.9973V16.6156C17.524 17.2558 17.005 17.7748 16.3647 17.7748H7.86458C7.22432 17.7748 6.70532 17.2558 6.70532 16.6156V15.9973C6.70532 14.2249 8.12775 12.7883 9.89281 12.7566L11.2574 16.4879L11.7281 14.4904L10.9556 13.1382H13.2737L12.5011 14.4904L12.9696 16.4879L14.3337 12.7566C16.1015 12.7883 17.524 14.2249 17.524 15.9973ZM10.0715 16.6156L9.14417 14.0803C8.39322 14.399 7.86458 15.1426 7.86458 15.9973V16.6156H9.02383H10.0715ZM8.63711 8.88795C8.63711 6.96811 10.195 5.41064 12.1149 5.41064C14.0343 5.41064 15.5922 6.96811 15.5922 8.88795C15.5922 10.8078 14.0343 12.3657 12.1149 12.3657C10.195 12.3657 8.63711 10.8078 8.63711 8.88795ZM9.79636 8.88795C9.79636 10.1657 10.8371 11.2065 12.1149 11.2065C13.3922 11.2065 14.4329 10.1657 14.4329 8.88795C14.4329 7.61066 13.3922 6.5699 12.1149 6.5699C10.8371 6.5699 9.79636 7.61066 9.79636 8.88795ZM16.3647 15.9973C16.3647 15.1426 15.8338 14.399 15.0851 14.0803L14.1601 16.6156H16.3647V15.9973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoaccounts);
export default __webpack_public_path__ + "static/media/goaccounts.0908c9db.svg";
export { ForwardRef as ReactComponent };